export const SHIFT_ADMIN_VIEWS = {
    MONTH: "month",
    DAY: "day"
};

export const SHIFT_ADMIN_ALL_FILTER_VALUE = "all";